import { range } from 'lodash';
import React from 'react';
import { Td, Th, Tr } from '../../../../shared/Table';
import {
  DataForDesignDrawingsManifold,
  DataForDesignDrawingsRoom,
} from '../../../designs/data-for-design-drawings/dataForDesignDrawingsResponse';

type PortRowProps = {
  name: string;
  manifold: DataForDesignDrawingsManifold;
  getValue: (room: DataForDesignDrawingsRoom, port: number) => string | number | null;
};

export const PortRow = ({ name, manifold, getValue }: PortRowProps) => (
  <Tr>
    <Th scope="row">{name}</Th>
    {manifold.rooms.map(room => (
      <React.Fragment key={room.roomId}>
        {range(1, room.numberOfPorts + 1).map(portIndex => (
          <Td key={portIndex}>{getValue(room, portIndex)}</Td>
        ))}
      </React.Fragment>
    ))}
  </Tr>
);
